export const SAVE_INSTANCE = 'SAVE_INSTANCE';
export const DELETE_INSTANCE = 'DELETE_INSTANCE';
export const UPDATE_INSTANCE = 'UPDATE_INSTANCE';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT = 'LOGOUT';
export const SAVE_ORG_IMAGE_BASE64 = 'SAVE_ORG_IMAGE_BASE64';
export const SAVE_USER_IMAGE_BASE46 = 'SAVE_USER_IMAGE_BASE46';
export const SAVE_USER_SIGN_BASE46 = 'SAVE_USER_SIGN_BASE46';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/actions.ts